// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-card {
    padding:20px 10px 20px 10px;
    width: auto;
    color: #fff;
    background: #dbdbdb;
    border-radius: 1.5rem;
    text-align: center;
    margin: 0px 5px 10px 5px;
    min-width: 180px;
    height: 140px;
    position: relative;
    box-shadow: 0 2rem 3rem rgb(132 139 200 / 52%);
}
.data-card h1{
    font-weight: 900;
    font-size: 1.8rem;
}
.data-card h6{
    font-weight: 500;
}
.item-svg{
    font-size: 18px;
    font-weight: 300;
    height: 30px;
}

@media (max-width:576px) {
    .data-card{
        width: calc(100% - 30px);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/componentsCss/DataCard.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,8CAA8C;AAClD;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ","sourcesContent":[".data-card {\n    padding:20px 10px 20px 10px;\n    width: auto;\n    color: #fff;\n    background: #dbdbdb;\n    border-radius: 1.5rem;\n    text-align: center;\n    margin: 0px 5px 10px 5px;\n    min-width: 180px;\n    height: 140px;\n    position: relative;\n    box-shadow: 0 2rem 3rem rgb(132 139 200 / 52%);\n}\n.data-card h1{\n    font-weight: 900;\n    font-size: 1.8rem;\n}\n.data-card h6{\n    font-weight: 500;\n}\n.item-svg{\n    font-size: 18px;\n    font-weight: 300;\n    height: 30px;\n}\n\n@media (max-width:576px) {\n    .data-card{\n        width: calc(100% - 30px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
